import React from 'react';
import PropTypes from 'prop-types';
import { Donut, DonutValue } from 'react-donut-component';

const PartSuitabilityIndicator = ({ partSuitability, highlightColor }) => {
	return (
		<Donut
			animate
			color="rgba(0,0,0,0.0.87)"
			indicatorColor={highlightColor ? highlightColor : 'rgba(0, 0, 0, 0.37)'}
			indicatorStrokeWidth={2.5}
			linecap="round"
			size={40}
			strokeWidth={8}
			trackColor="rgba(0, 0, 0, 0)"
			trackStrokeWidth={2.3}>
			<DonutValue showValue={false}>{partSuitability}</DonutValue>
			<div>{partSuitability}</div>
		</Donut>
	);
};

PartSuitabilityIndicator.propTypes = {
	partSuitability: PropTypes.number.isRequired
};

export default PartSuitabilityIndicator;
